/**
 * @generated SignedSource<<71671240585d64577d28738d8b3c6b60>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DigestSectionAccordion_jobRun$data = {
  readonly digestSections: ReadonlyArray<{
    readonly isComplete: boolean;
    readonly message: {
      readonly agentThoughtProcess: ReadonlyArray<{
        readonly subagentDescription: string | null | undefined;
        readonly subagentItems: ReadonlyArray<{
          readonly text: string | null | undefined;
          readonly thinking: string | null | undefined;
          readonly thinkingSummary: string | null | undefined;
          readonly toolUse: {
            readonly toolUse: {
              readonly id: string;
              readonly name: string;
            } | null | undefined;
            readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "SkillCluster_toolCall" | "ToolCallSheet_toolCall" | "V2AgentThoughtProcessRenderer_toolCall">;
          } | null | undefined;
        }> | null | undefined;
        readonly subagentOutput: string | null | undefined;
        readonly text: string | null | undefined;
        readonly thinking: string | null | undefined;
        readonly thinkingSummary: string | null | undefined;
        readonly toolUse: {
          readonly toolUse: {
            readonly id: string;
            readonly name: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"ChecklistToolCallResult_toolCall" | "SkillCluster_toolCall" | "ToolCallSheet_toolCall" | "V2AgentThoughtProcessRenderer_toolCall">;
        } | null | undefined;
      }>;
      readonly content: string;
      readonly endedAt: any | null | undefined;
      readonly startedAt: any;
      readonly " $fragmentSpreads": FragmentRefs<"messageWithToolReferences_message">;
    } | null | undefined;
    readonly section: string;
    readonly text: string | null | undefined;
  }>;
  readonly " $fragmentType": "DigestSectionAccordion_jobRun";
};
export type DigestSectionAccordion_jobRun$key = {
  readonly " $data"?: DigestSectionAccordion_jobRun$data;
  readonly " $fragmentSpreads": FragmentRefs<"DigestSectionAccordion_jobRun">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinking",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thinkingSummary",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMessageToolCall",
  "kind": "LinkedField",
  "name": "toolUse",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMessageToolUse",
      "kind": "LinkedField",
      "name": "toolUse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "V2AgentThoughtProcessRenderer_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChecklistToolCallResult_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToolCallSheet_toolCall"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillCluster_toolCall"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DigestSectionAccordion_jobRun",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLJobRunDigestOutputSection",
      "kind": "LinkedField",
      "name": "digestSections",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "section",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComplete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLFormattedMessage",
          "kind": "LinkedField",
          "name": "message",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "messageWithToolReferences_message"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLAgentThoughtProcessItem",
              "kind": "LinkedField",
              "name": "agentThoughtProcess",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subagentDescription",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subagentOutput",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "GraphQLAgentThoughtProcessItem",
                  "kind": "LinkedField",
                  "name": "subagentItems",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GraphQLJobRun",
  "abstractKey": null
};
})();

(node as any).hash = "12cab053d5a7f59deef5b142d97500f5";

export default node;
